export const SO_UNIQUE_TARIFF_CODE_PREFIX = "E3R-TOU"

export const FIXED_TARIFF_RATE_TYPE = "Fixed"
export const VARIABLE_TARIFF_RATE_TYPE = "Variable"

export const RENEWAL_WINDOW_DAYS = 49

// Shown only while SHOW_ELEC_VAT_RATE_CHANGE_INFO is on; retired by
// DEV.8 (SO-32498).
export const ELEC_VAT_RATE_CHANGE_HEADLINE =
  "From 1 October, electricity VAT temporarily drops from 5% to 0%."
export const ELEC_VAT_RATE_CHANGE_DETAIL =
  "Prices shown reflect the lower rate, but until 1 October you'll still pay 5% on electricity."
// Appended to the backend-driven VAT inclusion note while the flag is on;
// retired by SO-32498.
export const TARIFF_INFO_VAT_TRANSITIONAL_NOTE =
  "Until 1 October, you'll still pay electricity VAT at 5%."

// Suffixed to the backend-driven electricity VAT rate, e.g. "0% VAT from 1 Oct".
// Transitional like the note above, so it is gated by the same flag.
export const VAT_BADGE_SUFFIX = "VAT from 1 Oct"

// Pre-cutover the agreement's own rate is still 5%, so the badge names the
// legislated future rate rather than deriving it.
export const ELEC_VAT_BADGE_TRANSITIONAL = `0% ${VAT_BADGE_SUFFIX}`

export const EXIT_FEE_FOOTNOTE =
  "This is applied if you switch before the end of your contract."
